export const ADULTS_COUNT_PROP = 'adultsCount';
export const CHILDREN_COUNT_PROP = 'childrenCount';
export const YOUNG_CHILDREN_COUNT_PROP = 'youngChildrenCount';
export const DIETARY_QUESTION_PROPS = 'dietary';
export const HABITS_QUESTION_PROPS = 'habits';

export const FEEDS_QUESTION_PROPS = [
  ADULTS_COUNT_PROP,
  CHILDREN_COUNT_PROP,
  YOUNG_CHILDREN_COUNT_PROP,
];

export const DIETARY_QUESTIONS_PROPS = ['dietary'];

export const HABITS_QUESTIONS_PROPS = ['habits'];

export const FOOD_SELECTION_QUESTION_PROPS = [
  ...FEEDS_QUESTION_PROPS,
  ...DIETARY_QUESTIONS_PROPS,
  ...HABITS_QUESTIONS_PROPS,
];
